import { Component, OnInit } from '@angular/core';

import { arrayIsTruthy } from '@shared-helpers/array-object-helpers';

import { ProductionGroup } from '../../scripts/productionGroup';
import { ProductionQuantity } from '../../scripts/productionQuantity';
import { ProductionText } from '../../scripts/productionText';
import { DatahubService } from '../../services/datahub.service';

@Component({
  selector: 'production',
  templateUrl: './production.component.html',
  standalone: false,
})
export class ProductionComponent implements OnInit {
  public quantitySkfs: ProductionQuantity[] = [];
  public textSkfs: ProductionText[] = [];
  public hasProduction = false;
  public hasProductionGroup = false;
  public readonly timeSheet = this.datahub.timesheet;
  public isTimesheetApproved: boolean = this.timeSheet.isTimesheetApproved;

  constructor(private readonly datahub: DatahubService) {}

  public ngOnInit(): void {
    this.quantitySkfs = this.timeSheet.currentQuantityProduction;
    this.textSkfs = this.timeSheet.currentTextProduction;
    this.hasProduction = this.quantitySkfs.length > 0 || this.textSkfs.length > 0;
    this.hasProductionGroup = arrayIsTruthy(this.datahub.contract.value.skfGroupConfig);
  }

  public addGroup(): void {
    this.timeSheet.addProductionGroup$().subscribe();
  }

  public deleteGroup(group: ProductionGroup): void {
    this.timeSheet.flagForDelete(group);
    this.timeSheet.currentProductionGroups = this.datahub.timesheet.currentProductionGroups.filter((x) => x.id !== group.id);
  }
}
